import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageWithExpiry } from '../core-components/access/access.component';

@Injectable({
  providedIn: 'root'
})
export class AccessGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const access = StorageWithExpiry.get('APP_ACCESS');

    if (access === 'granted') {
      // if(this.router.url === '/' || this.router.url === '/access'){
      //   this.router.navigate(['/home']);
      // }
      // else{
        return true;
      // }
    }

    this.router.navigate(['/access']);
    return false;
  }
}
